const ChartDataIcon = () => {
    return(
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 8.33333C20.0748 7.03165 18.8647 6 16.9782 6C8.4681 6 12.9194 20.5 5 20.5" stroke="#30970B" stroke-width="1.5" stroke-linecap="round"/>
        <path d="M21 21H10C6.70017 21 5.05025 21 4.02513 19.9749C3 18.9497 3 17.2998 3 14V3" stroke="#30970B" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
    )
}

export default ChartDataIcon